import React from "react";
import {useParams} from "react-router-dom";
import Article1 from "./Article1";
import Article2 from "./Article2";
import Article3 from "./Article3";
import Article4 from "./Article4";
import Article5 from "./Article5";
import Article6 from "./Article6";
import Article7 from "./Article7";
import Article8 from "./Article8";

export default function Article() {

    // Get the articleId param from the URL.
    let { articleId } = useParams();

    switch (articleId) {
        case '1':
            return <Article1 />;
        case '2':
            return <Article2 />;
        case '3':
            return <Article3 />;
        case '4':
            return <Article4 />;
        case '5':
            return <Article5 />;
        case '6':
            return <Article6 />;
        case '7':
            return <Article7 />;
        case '8':
            return <Article8 />;
        default:
            return  <div className="site-section">
                <div className="container">
                    <div className="row">
                        Запрашиваемая страница блога не найдена.
                    </div>
                </div>
            </div>;
    }

}